import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Smartphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { TableWidget } from '../../../components/table-widget/TableWidget';
import './MobileApps.scss';
import { LoadingSpinner } from '../../../components/loading-spinner/LoadingSpinner';

export interface Props {
  deviceData: any;
}

export function MobileApps(props: Props) {
  const { operatorId, cpeId } = useParams();
  const { t } = useTranslation();
  const [params, setParams] = useState<any>();

  async function getDnsGroupDetails(row: any) {
    const params = {
      domain: row.fqdn,
      date: row.time_stamp,
      reason: row.reason,
      profile: row.profile_code,
      deviceId: props.deviceData.id,
    };

    setParams(params);

    //setShowDnsDetailsModal(true);
  }

  console.log(props.deviceData);

  //const timePeriod = watch('timePeriod');

  return (
    <section id="mobile-apps-tab" className="dd-mobile-apps">
      <header className="dd-mobile-apps-hd">
        <span className="dd-mobile-apps-icon" aria-hidden="true">
          <Smartphone size={16} strokeWidth={1.75} />
        </span>
        <div className="dd-mobile-apps-hd-text">
          <h2 className="bd-h2">{t('deviceDetails.mobileApps.title')}</h2>
          <span className="bd-meta">{t('deviceDetails.mobileApps.subtitle')}</span>
        </div>
      </header>

      {props.deviceData?.id ? (
        <div className="dd-mobile-apps-table">
          <TableWidget
            url={`op/${operatorId}/cpe/${cpeId}/d/${props.deviceData.id}/apps_table`}
            hasSearch={true}
            countPerPage={8}
            title={t('deviceDetails.mobileApps.tableTitle')}
          />
        </div>
      ) : !props.deviceData ? (
        <LoadingSpinner text={t('deviceDetails.page.loadingDevice')} />
      ) : (
        <div className="dd-mobile-apps-empty" role="status">
          <span className="dd-mobile-apps-empty-icon" aria-hidden="true">
            <Smartphone size={20} strokeWidth={1.75} />
          </span>
          <h3 className="bd-h3">{t('deviceDetails.mobileApps.emptyTitle')}</h3>
          <span className="bd-meta">{t('deviceDetails.mobileApps.emptyBody')}</span>
        </div>
      )}
    </section>
  );
}
